"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.eventTypes.conversation_analysis': 'Análisis de Conversación',
    'webhook.eventTypes.avatar_updated': 'Avatar Actualizado',
    'webhook.eventTypes.avatar_deleted': 'Avatar Eliminado',
    'webhook.eventTypes.avatar_test_complete': 'Prueba de Avatar Completada',
    'webhook.eventTypes.knowledge_added': 'Conocimiento Añadido',
    'webhook.eventTypes.knowledge_removed': 'Conocimiento Eliminado',
    'webhook.eventTypes.knowledge_notify': 'Editar Conocimiento',
};
